<template>
  <a-carousel autoplay style="height:100%" :key="$t('home.cover.title1')" >
    <div class="carousel">
      <div
        class="carousel-bg"
        style="background-image: url('/statics/images/image_1.png')"
      />
      <div class="caption">
        <div class="text-h2 main_line" v-html="$t('home.cover.title1')">
        </div>
        <br /><br />
        <div class="text-h5">{{$t('home.cover.subtitle1')}}</div>
      </div>
    </div>
    <div class="carousel">
      <div
        class="carousel-bg"
        style="background-image: url('/statics/images/image_2.png')"
      />
      <div class="caption">
        <div class="text-h2 main_line" v-html="$t('home.cover.title2')">
        </div>
        <br /><br />
        <div class="text-h5">{{$t('home.cover.subtitle2')}}</div>
      </div>
    </div>
    <div class="carousel">
      <div
        class="carousel-bg"
        style="background-image: url('/statics/images/image_3.png')"
      />
      <div class="caption">
        <div class="text-h2 main_line" v-html="$t('home.cover.title3')">
          
        </div>
        <br /><br />
        <div class="text-h5">{{$t('home.cover.subtitle3')}}</div>
      </div>
    </div>
  </a-carousel>
</template>

<script>

export default {
  name: "Cover",
  data() {
    return {
      theme_color: "rgb(123,170,74)",
    };
  },
  
}
</script>

<style scoped>
/* For demo */
.carousel {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  margin: auto;
  overflow: clip;
  display: flex;
  align-items: center; /* vertical */
  justify-content: center; /* horizontal */
  font-size: 8vw;
}

.carousel-bg {
  width: 100%;
  height: 100vh;
  object-fit: cover;

  filter: brightness(40%);

  overflow: hidden;
  background-size: cover;
  background-position: center;
}

.caption {
  width: 100%;
  height: 400px;
    font-size: 4vw;

  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  text-align: center;
}

.main_line {

  letter-spacing: 5px;
  line-height: 60px;
  font-weight: 600;
}

.animation_1 {
  -webkit-animation: bounceIn 1s ease-in 800ms both;
  animation: bounceIn 1s ease-in 800ms both;
}
.animation_2 {
  -webkit-animation: flipInX 2s ease-in-out 800ms both;
  animation: flipInX 1s ease-in-out 800ms both;
}
.animation_3 {
  -webkit-animation: lightSpeedIn 1s ease-in 800ms both;
  animation: lightSpeedIn 1s ease-in 800ms both;
}
</style>
